import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import { getDateFnsLocale } from "@/lib/dateFormat";

interface DashboardTrustStripProps {
  dataUpdatedAt: number;
}

export function DashboardTrustStrip({
  dataUpdatedAt,
}: DashboardTrustStripProps): JSX.Element | null {
  const { t, i18n } = useTranslation();
  const dateLocale = getDateFnsLocale(i18n.language);

  const updatedLabel = useMemo(() => {
    try {
      return format(new Date(dataUpdatedAt), "PP", { locale: dateLocale });
    } catch {
      return "";
    }
  }, [dataUpdatedAt, dateLocale]);

  if (!updatedLabel) {
    return null;
  }

  return (
    <div className="text-xs text-muted-foreground/65">
      {t("dashboard.trust.lastUpdated", { date: updatedLabel })}
    </div>
  );
}
